import React from 'react';
import { Tooltip, Typography, Box } from '@mui/material';

import icon_snmp from 'assets/images/icons/icn_Info_solid.svg';
import icon_snmp_hover from 'assets/images/icons/icn_info_solid_hover.svg';

export default function CustomTooltip() {
  return (
    <Tooltip
      arrow
      placement="right"
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 850,
            backgroundColor: '#4D4D4D',
          },
        },
      }}
      title={
        <Box>
          <Typography variant="body2" fontSize={13}>
            Note: A Slow Roam is a roam event that does not complete within the roam-time threshold; Slow Roams % = slow roam events ÷ total roam events (an event taking over 10
            seconds is not counted as a roam). Back-and-Forth Roams are clients repeatedly roaming between the same two APs, as a share of total roam events.
          </Typography>
          <Typography fontWeight="bold" fontSize={13} sx={{ mt: 2 }}>{`Good — Connect Time for Most Users (P95) ≤ 2s and Slow Roams ≤ 5%`}</Typography>
          <Typography variant="body2" fontSize={13}>
            Roaming is stable. Users moving between APs experience no interruptions or lag.
          </Typography>

          <Typography fontWeight="bold" fontSize={13} sx={{ mt: 2 }}>
            {`Warning — Connect Time for Most Users (P95) 2–4s, or Slow Roams 5–15%, or Back-and-Forth Roams 1-3%`}
          </Typography>
          <Typography variant="body2" fontSize={13}>
            Roaming is beginning to slow down. Users may notice brief lag along specific movement paths.
          </Typography>
          <Typography fontWeight="bold" fontSize={13}>
            Recommended Actions:
          </Typography>
          <ul style={{ margin: 0, paddingLeft: 16, fontSize: 13 }}>
            <li>Inspect the worst paths in the Top AP Pair list.</li>
            <li>Verify coverage overlap and roaming assistance (802.11k/r/v) settings.</li>
          </ul>

          <Typography fontWeight="bold" fontSize={13} sx={{ mt: 2 }}>
            {`Critical — Connect Time for Most Users (P95) > 4s, or Slow Roams > 15%, or Back-and-Forth Roams > 3%`}
          </Typography>
          <Typography variant="body2" fontSize={13}>
            Roaming is severely degraded, causing dropped calls and forced reconnections while moving.
          </Typography>
          <Typography fontWeight="bold" fontSize={13}>
            Recommended Actions:
          </Typography>
          <ul style={{ margin: 0, paddingLeft: 16, fontSize: 13 }}>
            <li>Improve AP density, transmit power, and channel allocation.</li>
            <li>Prioritize high-density and mission-critical areas first.</li>
          </ul>
        </Box>
      }
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: 16,
          '& img': {
            content: `url(${icon_snmp})`,
          },
          '&:hover img': {
            content: `url(${icon_snmp_hover})`,
          },
        }}
      >
        <img src={icon_snmp} alt="" style={{ width: 16, height: 16, cursor: 'pointer' }} />
      </Box>
    </Tooltip>
  );
}
